module.exports = "https://www.gc-pro.gnp.com.mx/bb24fca9f530a04d360768242251b2e5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animation_640_modal.gif
// module id = 8033
// module chunks = 0